import { render, staticRenderFns } from "./addSituation.vue?vue&type=template&id=39db6ac1&scoped=true"
import script from "./addSituation.vue?vue&type=script&lang=js"
export * from "./addSituation.vue?vue&type=script&lang=js"
import style0 from "./addSituation.vue?vue&type=style&index=0&id=39db6ac1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39db6ac1",
  null
  
)

export default component.exports